import {h} from 'preact';
import LinksToSocialNetworks from "../../components/LinksToSocialNetworks/LinksToSocialNetworks";
import CasesGrid from "../../components/CasesGrid/CasesGrid";
import FeedbackSlider from "../../components/FeedbackSlider/FeedbackSlider";
import styles from "./style.scss"
import ReturnBack from "./ReturnBack";

const Success = () => {
    return (
        <main id="main-container" className={styles.wrapper} main-attr>
            <ReturnBack></ReturnBack>
            <h1>Общество с ограниченной ответственностью “ИТК”</h1>
            <p><strong>Сокращенное наименование:</strong> ООО “ИТК”</p>
            <p><strong>Дата создания:</strong> 20.04.2023</p>
            <p><strong>Полное наименование организации:</strong> ООО «ИТК»</p>
            <p><strong>ИНН организации:</strong> 6154164899</p>
            <p><strong>Основной ОКВЭД:</strong> (62.09) Деятельность, связанная с использованием вычислительной техники и информационных технологий, прочая</p>

            <h2>Учредители:</h2>
            <ul>
                <li>Тетеревлев Игорь Николаевич ИНН 615425657556</li>
            </ul>

            <p><strong>Юридический адрес:</strong> 347900, Ростовская область, г.о. город Таганрог, г Таганрог, пер. Тургеневский, 11, ком. 1-7.</p>
            <p><strong>Фактический адрес:</strong> 347900, Ростовская область, г.о. город Таганрог, г Таганрог, пер. Тургеневский, 11, ком. 1-7.</p>
            <p><strong>Адрес организации (место нахождения):</strong> 347900, Ростовская обл., г. Таганрог, пер. Тургеневский, д. 11, ком. 1-7</p>
            <p>Образовательная организация представительств и филиалов в том числе, находящихся за пределами Российской Федерации не имеет.</p>

            <h2>График работы:</h2>
            <ul>
                <li>Пн 9.00-18.00</li>
                <li>Вт 9.00-18.00</li>
                <li>Ср 9.00-18.00</li>
                <li>Чт 9.00-18.00</li>
                <li>Пт 9.00-18.00</li>
                <li>Сб выходной</li>
                <li>Вс выходной</li>
            </ul>

            <h2>Контактная информация</h2>
            &nbsp;
            <h3>Номера телефонов:</h3>
            <ul>
                <li>+7 (995) 930-10-20</li>
                <li>+7-977-012-90-66</li>
            </ul>
            <h3>Адреса электронной почты:</h3>
            <ul>
                <li><a href="mailto:it.consult.tag@gmail.com">it.consult.tag@gmail.com</a></li>
                <li><a href="mailto:itk.academy@yandex.ru">itk.academy@yandex.ru</a></li>
            </ul>

            <p><strong>Адрес официального сайта:</strong> <a href="https://itconsult-web.ru">https://itconsult-web.ru</a></p>
            <p><strong>Место оказания образовательной деятельности:</strong> 347900, Ростовская область, г.о. город Таганрог, г Таганрог, пер. Тургеневский, 11, ком. 1-7.</p>
            <p>Лицензия на осуществление образовательной деятельности <strong>&nbsp;№ Л035-01276-61/00736842 от 11.10.2023 г.</strong></p>
            <p>У ООО «ИТК» отсутствуют образовательные программы, требующие государственной аккредитации.</p>

            <li><a href="/info/documentation-511">Документация в соответствии с приказом Минцифры России от 02.06.2025 № 511</a></li>
        </main>
    );
};

export default Success;